import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl, Validators, AbstractControl } from '@angular/forms';
import { TravelMixData } from 'src/app/models/TravelMixData.model';
import { LuggageAmounteServiceClass } from "src/app/models/LuggageAmounteServiceClass.model";
import { Season } from 'src/app/models/Season.model';
import { TransportMode } from 'src/app/models/transportMode.model';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { LuggageAmountWindowComponent } from './luggage-amount-window/luggage-amount-window.component';
import { ServiceClass } from 'src/app/models/serviceClass.model';
import { LuggageType } from 'src/app/models/luggageType.model';
import { changeServiceClassesOrder } from 'src/app/helper/changeServiceClassesOrder';
import { dynamicLocaleCompareWithOptions } from 'src/app/helper/sortFunctions';

@Component({
  selector: 'app-travelmix',
  templateUrl: './travelmix.component.html',
  styleUrls: ['./travelmix.component.scss']
})
export class TravelmixComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder, public dialog: MatDialog) { }

  @Input('form') parentForm: FormGroup;
  @Input('data') data: TravelMixData[];
  @Input('seasons') seasons: Season[];
  @Input('transportModes') transportModes: TransportMode[];
  @Input('serviceClasses') serviceClasses: ServiceClass[];
  @Input('luggageTypes') luggageTypes: LuggageType[];
  @Input('isEditable') isEditable: boolean;
  @Output() validationCheckOutput = new EventEmitter<boolean>();

  form: FormGroup;
  displayedColumns: string[] = ['name', 'ac', 'hc', 'seasons', 'transportmode', 'actions', 'markAsDelete'];
  dataSource: any;
  uniqueNameTitle: string = "Name needs to be Unique in this region";
  uniqueValidationList: boolean[] = [];
  filteredData: TravelMixData[];

  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('travelMixes', this._formBuilder.array([]));
    this.form.setControl('travelMixes', this.dataAsFormArray());
    if (this.isEditable) {
      this.disable();
    }
    this.dataSource = this.filterDataForm();
    this.serviceClasses = changeServiceClassesOrder(this.serviceClasses);
    this.seasons.sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'name'));
    this.transportModes.sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'name'));
    this.filteredData = this.data.filter(f=>f.isMarkedAsDelete == false);
    this.initializeUniqueValidation();
  }
  dataAsFormArray(): FormArray {
    const fgs = this.data.map(o => this.asFormGroup(o));
    return new FormArray(fgs);
  }

  asFormGroup(o: TravelMixData): FormGroup {

    const fg = new FormGroup({
      id: new FormControl(o.id, Validators.required),
      name: new FormControl(o.name, Validators.required),
      airportConnection: new FormControl(o.airportConnection, Validators.required),
      harbourConnection: new FormControl(o.harbourConnection, Validators.required),
      seasonIds: new FormControl(o.seasonIds, Validators.required),
      transportModeIds: new FormControl(o.transportModeIds, Validators.required),
      luggageAmounteServiceClasses: new FormControl(o.luggageAmounteServiceClasses, Validators.required),
      isMarkedAsDelete: new FormControl(o.isMarkedAsDelete),
    });
    return fg;
  }

  initializeUniqueValidation() {
    let isUnique = true;
    for (let i = 0; i < this.filteredData.length; i++) {
      isUnique = true;
      for (let j = 0; j < this.filteredData.length; j++) {
        if (i == j) {
          continue;
        }
        if (this.filteredData[i].name == this.filteredData[j].name) {
          isUnique = false;
          break;
        }
      }
      this.uniqueValidationList.push(isUnique);
    }
    this.emitValidation();
  }


  emitValidation() {
    let check: boolean = true;
    for (let i = 0; i < this.filteredData.length; i++) {
      const element = this.filteredData[i];
      if (!element.isMarkedAsDelete && !this.uniqueValidationList[i]) {
        check = false;
      }
    }
    this.validationCheckOutput.emit(check);
  }

  refreshUniqueValidation(skipIndex: number) {
    let isUnique = true;
    for (let i = 0; i < this.filteredData.length; i++) {
      isUnique = true;
      if (i == skipIndex) {
        continue;
      }

      for (let j = 0; j < this.filteredData.length; j++) {
        if (i == j) {
          continue;
        }

        if (this.filteredData[i].name == this.filteredData[j].name) {
          isUnique = false;
          break;
        }
      }
      this.uniqueValidationList[i] = isUnique;
    }
  }

  uniqueValidation(name: string, index: number) {
    if (this.filteredData[index].isMarkedAsDelete == true) {
      return;
    }

    let isUnique: boolean = true;

    for (let i = 0; i < this.filteredData.length; i++) {
      if (i == index) {
        continue;
      }

      if (this.filteredData[i].name == name) {
        isUnique = false;
        break;
      }

    }
    this.uniqueValidationList[index] = isUnique;
    this.filteredData[index].name = name;

    this.refreshUniqueValidation(index);

    this.emitValidation();
  }

  showTMNameWarning(index: number) {
    return !this.uniqueValidationList[index];
  }

  removeTravelMix(element: FormGroup, index: number) {
    element.get('isMarkedAsDelete').patchValue(true);
    this.dataSource = this.filterDataForm();
    this.uniqueValidationList.splice(index, 1);
    this.filteredData.splice(index, 1);
    this.refreshUniqueValidation(-1);
    this.emitValidation();
  }

  filterDataForm(): MatTableDataSource<any> {
    var source = new MatTableDataSource((<FormArray>this.form.get('travelMixes')).controls);
    source.filterPredicate = function (data: AbstractControl, filter: string): boolean {
      return data.value.isMarkedAsDelete === false;
    };
    source.filter = 'irrelevantertext';
    return source;
  }
  openEditor(element: FormGroup) {
    let lascCtrl = element.get('luggageAmounteServiceClasses');
    let overlayData = lascCtrl.value as LuggageAmounteServiceClass[];

    const dialogRef = this.dialog.open(LuggageAmountWindowComponent,
      {
        width: '1480px',
        data: {
          form: element,
          data: overlayData,
          rowHeaders: this.serviceClasses,
          colHeaders: this.luggageTypes,
          isEditable: this.isEditable
        }
      });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.save) {
        lascCtrl.patchValue(result.data);
      }
    })
  }
  disable() {
    this.form.controls['travelMixes'].disable();
  }

  getTransportModeToolTipData(formGroup: FormGroup): string {
    let transportModeIds: number[] = formGroup.get('transportModeIds').value;
    return this.getTooltipMessage(transportModeIds, this.transportModes);
  }

  getSeasonsToolTipData(formGroup: FormGroup): string {
    let seasonIds: number[] = formGroup.get('seasonIds').value;
    return this.getTooltipMessage(seasonIds, this.seasons);
  }

  getTooltipMessage(ids: number[], source: TransportMode[] | Season[]): string {
    if (ids && ids.length) {
      let msg: string = '';
      ids.forEach(id => {
        let name: string = source.find(f => f.id === id).name;
        msg += name + "\n";
      });
      return msg;
    } else {
      return "";
    }
  }
}
